import {
  SelectedLandLineInterfaceState, initialSelectedLandLineState
} from '../state/selected-land-line.state';
import { ESetSelectedLandLineActions, SelectedLandlineActions } from '../actions/selected-landline.actions';

export function landLineReducer(state: SelectedLandLineInterfaceState = initialSelectedLandLineState, action: SelectedLandlineActions): SelectedLandLineInterfaceState {
  switch (action.type) {
    case ESetSelectedLandLineActions.SetSelectedLandLine: {
      return { ...state, line: action.payload };
    }

    default:
      return state;
  }
}
